@let sidenav = sidenavContent();

<div class="flex flex-col w-full h-full overflow-hidden">
  <div class="flex flex-col overflow-hidden w-full h-full p-6">
    <div class="flex justify-between">
      <div>

      </div>
      <a href="" class="close-link flex" (click)="onClose($event)">
        <fa-icon class="si-icon" [icon]="['fal', 'xmark']"></fa-icon>
      </a>
    </div>
    @if (sidenav?.template) {
      <ng-template *ngTemplateOutlet="sidenav.template"></ng-template>
    }
  </div>
</div>

